import angular from 'angular';
import firebase from 'firebase/app';
import 'firebase/messaging';
import toastr from 'toastr';
import firebaseConfig from '../firebase.config.js';

const PROCITAN = 'Procitan';

toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-bottom-right',
    preventDuplicates: false,
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: 0,
    extendedTimeOut: 0,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
    tapToDismiss: false
};

const module = angular.module('messaging', []);
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();

const service = function(DS) {
    let comments = [];

    messaging.onMessage(function(payload) {
        console.log('Message received. ', payload);
        toastr['success'](`${payload.data.sender} kaže: ${payload.data.poruka}`);
    });

    messaging.onTokenRefresh(function() {
        getToken();
    });

    function requestPermission() {
        console.log('Requesting permission...');
        messaging
            .requestPermission()
            .then(function() {
                toastr['success']('Notification permission granted.');
                getToken();
            })
            .catch(function(err) {
                console.log('Unable to get permission to notify.', err);
            });

        // toastr['success']('Notification permission granted.');
    }

    function sendTokenToServer(currentToken) {
        const Token = DS.definitions['Token'];
        Token.create({ token: currentToken }).then(
            response => {
                toastr['success']('Token uspiješno snimljen');
            },
            error => {
                console.log(error);
                toastr['error']('Nisam uspio pohraniti token');
            }
        );
    }

    function getToken() {
        messaging
            .getToken()
            .then(function(refreshedToken) {
                toastr['success']('Token refreshed.');
                sendTokenToServer(refreshedToken);
            })
            .catch(function(err) {
                console.log(err);
                toastr['error']('Unable to retrieve refreshed token');
            });
    }

    function getComments() {
        return DS.findAll('NeprocitanKomentar', { limit: 20, offset: 0 }, { bypassCache: true }).then(response => {
            comments = [...response];
            return comments;
        });
    }

    function updateComment(comment) {
        const Comment = DS.definitions['Komentar'];
        return Comment.update(comment.id, {
            status: PROCITAN,
            radni_nalog: comment.radni_nalog,
            poruka: comment.poruka
        });
    }

    return {
        requestPermission,
        getComments,
        updateComment
    };
};
service.$inject = ['DS'];
module.service('messaging', service);

export { module };



// WEBPACK FOOTER //
// ./app/messaging.js